import { Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { useSnackbar } from 'notistack';
import React from 'react';
import { useQueryClient } from 'react-query';
import { CerebroLinkButton } from '../../../shared/components';
import { useApi } from '../../../shared/context';
import { QueryKeys } from '../../../shared/hooks';
import { DealPartnerContact } from '../../../shared/models';
import { CompanyContact } from '../../../shared/models/CompanyContact';
import { CerebroApiEndpoints } from '../../../shared/utils/api';
import { getResponseData } from '../../../shared/utils/axios';

interface AvailableContactListProps {
	dealPartnerGuid: string | undefined;
	dataRoomGuid: string | undefined;
	contacts: DealPartnerContact[];
}

export const AvailableContactList: React.FC<AvailableContactListProps> = ({ dealPartnerGuid, dataRoomGuid, contacts }) => {
	const api = useApi();
	const snackbar = useSnackbar();
	const client = useQueryClient();
	const [contactList, setContactList] = React.useState<DealPartnerContact[]>(contacts);

	const associateToDataRoom = async (contact: DealPartnerContact) => {
		await getResponseData<DealPartnerContact>(
			api.post(CerebroApiEndpoints.DataRoomPartnerContacts.Associate(dataRoomGuid, contact.guid))
		);

		snackbar.enqueueSnackbar('Deal partner contact was added to data room.', { variant: 'success' });
		const index = contactList.findIndex(m => m.guid == contact.guid);
        contactList.splice(index, 1);
		setContactList([...contactList]);
        client.invalidateQueries(QueryKeys.DataRoomPartnerContacts.Root(dataRoomGuid));
	};

	return (
		<Table>
			<TableHead>
				<TableRow>
					<TableCell>Name</TableCell>
					<TableCell>Email</TableCell>
					<TableCell></TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{contactList.map(contact => {
					return (
						<TableRow key={contact.guid}>
							<TableCell>
								{contact.firstName} {contact.lastName}
							</TableCell>
							<TableCell>{contact.emailAddress}</TableCell>
							<TableCell>
								<CerebroLinkButton onClick={() => associateToDataRoom(contact)}>
									Associate
								</CerebroLinkButton>
							</TableCell>
						</TableRow>
					);
				})}
				{contactList.length == 0 && (
					<TableRow>
						<TableCell colSpan={3} sx={{ textAlign: 'center' }}>
							No additional deal partner contacts available to add to deal.
						</TableCell>
					</TableRow>
				)}
			</TableBody>
		</Table>
	);
};
